// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__2_OFb","content":"Consent_content__f9W9Z","footer":"Consent_footer__3vA5u"};